import { CURRENCIES } from "@/lib/constants";

export function formatCurrency(value, currency) {
  const c = CURRENCIES[currency] || CURRENCIES.INR;
  return `${c.symbol} ${new Intl.NumberFormat(c.locale).format(Math.round(value || 0))}`;
}

export function formatCompact(value, currency) {
  const c = CURRENCIES[currency] || CURRENCIES.INR;
  const v = value || 0;
  const abs = Math.abs(v);
  if (currency === "INR") {
    if (abs >= 1e7) return `${c.symbol} ${(v / 1e7).toFixed(2)} Cr`;
    if (abs >= 1e5) return `${c.symbol} ${(v / 1e5).toFixed(2)} L`;
    return `${c.symbol} ${Math.round(v).toLocaleString("en-IN")}`;
  }
  if (abs >= 1e6) return `${c.symbol} ${(v / 1e6).toFixed(2)}M`;
  if (abs >= 1e3) return `${c.symbol} ${(v / 1e3).toFixed(1)}K`;
  return `${c.symbol} ${Math.round(v).toLocaleString(c.locale)}`;
}

export function formatShort(value, currency) {
  const c = CURRENCIES[currency] || CURRENCIES.INR;
  const v = value || 0;
  if (currency === "INR") {
    if (Math.abs(v) >= 1e7) return `${(v / 1e7).toFixed(1)}Cr`;
    if (Math.abs(v) >= 1e5) return `${(v / 1e5).toFixed(0)}L`;
    return `${Math.round(v / 1000)}K`;
  }
  if (Math.abs(v) >= 1e6) return `${(v / 1e6).toFixed(1)}M`;
  if (Math.abs(v) >= 1e3) return `${Math.round(v / 1e3)}K`;
  return `${Math.round(v)}`;
}
